import React from "react";

import { MdCheckBoxOutlineBlank } from "@react-icons/all-files/md/MdCheckBoxOutlineBlank";
import { MdCheckBox } from "@react-icons/all-files/md/MdCheckBox";

const Item = ({
  item,
  isSelected,
  onClick,
  doShowAddIcon = true,
  onlyTriggerOnIconClick = false,
}) => (
  <span
    className="Select__item"
    onClick={(onlyTriggerOnIconClick ? undefined : onClick)}
  >
    {
      isSelected
        && (
        <span
          onClick={onlyTriggerOnIconClick ? onClick : undefined}
          className="Select__item-icon"
        >
          <MdCheckBox
            size="1.2em"
            color="#428bca"
          />
        </span>
        )
    }
    {
      (doShowAddIcon && !isSelected)
        && (
        <span
          onClick={onlyTriggerOnIconClick ? onClick : undefined}
          className="Select__item-icon"
        >
          <MdCheckBoxOutlineBlank
            size="1.2em"
            color="#428bca"
          />
        </span>
        )
    }
    <span>
      {item.label}
    </span>
  </span>
);

export default Item;
